import React, { FC } from 'react';
import { ReactComponent as NotAllocated } from '../../../assets/ClientCheck/NotAllocated.svg';

export const NotAllocatedIcon: FC = () => <NotAllocated />;
